import { useState, useEffect, ChangeEvent } from "react";
import { useLanguage } from "../lib/LanguageContext";
import { getLanguageDirection } from "../lib/funcs";

const defaultLanguageData = require("../lib/lang/en.json");

export default function LanguageSelector() {
  const urlParams = new URLSearchParams(window.location.search);

  const getInitialLang = () => {
    const qp = (urlParams.get("lang") || "").toLowerCase();
    if (qp) return qp;
    try {
      const saved = localStorage.getItem("lang") || "";
      if (saved) return saved.toLowerCase();
    } catch (e) {}
    return "en";
  };

  const [selectedLanguage, setSelectedLanguage] = useState(getInitialLang());
  const { languageData, setLanguageData, setLanguageCode } = useLanguage();

  document.body.dir = getLanguageDirection(languageData);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const newSelectedLanguage = (event.target.value || "en").toLowerCase();

    setSelectedLanguage(newSelectedLanguage);

    // Persist and reflect in URL
    try { localStorage.setItem("lang", newSelectedLanguage); } catch (e) {}
    if (newSelectedLanguage) {
      urlParams.set("lang", newSelectedLanguage);
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${urlParams.toString()}`
      );
    }
    if (setLanguageCode) setLanguageCode(newSelectedLanguage);
  };

  useEffect(() => {
    const lang = (selectedLanguage || "en").toLowerCase();

    // Try cached language data first to avoid flicker
    if (lang !== "en") {
      try {
        const cached = localStorage.getItem(`LANGUAGE_DATA_${lang}`);
        if (cached) {
          setLanguageData(JSON.parse(cached));
        }
      } catch (e) {}
    }

    if (lang === "en") {
      setLanguageData(defaultLanguageData.en);
      try { localStorage.setItem("LANGUAGE_DATA_en", JSON.stringify(defaultLanguageData.en)); } catch (e) {}
      return;
    }

    import(`/src/lib/lang/${lang}.json`)
      .then((data) => {
        const ld = data.default[lang];
        setLanguageData(ld);
        try { localStorage.setItem(`LANGUAGE_DATA_${lang}`, JSON.stringify(ld)); } catch (e) {}
      })
      .catch((error) => {
        console.error(`Error loading language data: ${error}`);
      });
  }, [selectedLanguage, setLanguageData]);

  return null;
}
